module.exports = __webpack_public_path__ + "static/media/final_graph_foodlegend.de34aab1.svg";